import styled from 'styled-components'

export const SplitFields = styled.div`
	display: flex;
`
export const Stereotypes = styled.div`
	margin-top: 20px;
`
